var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15625 10.5469H19.8438M9.15625 14.1094H14.5M2.92188 15.9025C2.92188 17.8025 4.25544 19.4579 6.13644 19.7346C7.47712 19.9317 8.83206 20.0825 10.2013 20.1846C10.6169 20.2155 10.9969 20.434 11.2284 20.7796L14.5 25.6875L17.7716 20.7796C17.8863 20.6089 18.0385 20.4666 18.2165 20.3635C18.3945 20.2604 18.5936 20.1992 18.7987 20.1846C20.1586 20.0831 21.5144 19.933 22.8636 19.7346C24.7446 19.4579 26.0781 17.8037 26.0781 15.9013V8.75494C26.0781 6.85257 24.7446 5.19838 22.8636 4.92169C20.0943 4.51523 17.299 4.31162 14.5 4.3125C11.6595 4.3125 8.8665 4.52032 6.13644 4.92169C4.25544 5.19838 2.92188 6.85375 2.92188 8.75494V15.9013V15.9025Z",
    stroke: "#00C0D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/socialMedia.cdf8469e0952dd4eb7cab2e735aa5920.svg";
export { ForwardRef as ReactComponent };